<template>
  <div class="add-homework-container">
    <div class="page_info">
      <div class="page_header">
        <div class="mwow-detail-header" style="width: 100%">
          <div class="left">
            <div class="back-btn" @click="$router.go(-1)">
              <i class="el-icon-arrow-left"></i>
              <span>返回</span>
            </div>
          </div>
          <div class="mid">
            <p>添加练习</p>
          </div>
        </div>
      </div>
      <div class="page_content">
        <div class="bottom_top">基本信息</div>
        <el-form
          size="mini"
          ref="form"
          :model="searchInfo"
          label-width="90px"
          :rules="rules"
          @submit.native.prevent
        >
          <el-form-item label="练习名称：" prop="title">
            <el-input
              v-model="searchInfo.title"
              placeholder="请输入练习名称"
              clearable
              maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item label="发布类型：" prop="type">
            <span
              class="chooseIn"
              @click="changeInputAgain"
              v-if="allpeople != 0"
              >已选择 <span class="mwow-green">{{ allpeople }}</span> 人</span
            >
            <el-select
              v-model="searchInfo.type"
              placeholder="请选择"
              ref="multiSelect"
            >
              <el-option
                v-for="item in student_type"
                :key="item.value"
                :label="item.value"
                :value="Number(item.key)"
                @click.native="changeInput(item.key)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发布时间：" prop="publish_type">
            <div class="publish_type_info">
              练习发布成功后学员会收到公众号消息
            </div>
            <div class="special-radio-group">
              <el-radio-group
                v-model.number="searchInfo.publish_type"
                @change="handleRadioGroup"
              >
                <el-radio :label="1">立即发布</el-radio>
                <el-radio :label="2">定时发布</el-radio>
              </el-radio-group>
            </div>
            <div v-if="searchInfo.publish_type == 2" class="publishBox">
              <el-date-picker
                type="datetime"
                value-format="yyyy-MM-dd HH"
                format="yyyy-MM-dd HH:mm"
                v-model="expireTimeClass"
                @change="datechooseClass"
                placeholder="选择日期时间"
                :picker-options="expireTimeOption"
                popper-class="choosedatetime"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <!-- <el-form-item label="截止时间:" prop="deadlineTime">
            <div class="publish_type_info">
              在截止时间之前教师批改后可让学员重复提交练习
            </div>
            <el-date-picker
              type="datetime"
              value-format="yyyy-MM-dd HH"
              format="yyyy-MM-dd HH:mm"
              clearable
              v-model="searchInfo.deadlineTime"
              @change="dateDeadline"
              placeholder="选择日期时间"
              :picker-options="deadlineTimeOption"
              popper-class="choosedatetime"
            >
            </el-date-picker>
          </el-form-item> -->
          <!-- <el-form-item label="练习提醒：">
            <span class="greencolor">发布后给学员推送公众号模板消息</span>
          </el-form-item> -->
        </el-form>
      </div>
    </div>
    <div class="page_content_bottom">
      <div class="bottom_top">练习要求</div>
      <div class="excisetips">
        <uploadBox @setContentList="contentList"></uploadBox>
        <div class="tipsBottom">
          <div>温馨提示：</div>
          <div>可选择门店授权教材中的课后练习内容；</div>
          <div>
            图片支持 jpeg、jpg、png、gif格式，每张图片小于15M，最多添加9张；
          </div>
          <div>音频支持 wav、flac、mp3，最多添加9个；</div>
          <div>视频支持 mp4、mov格式，每个视频小于500M，最多添加9个；</div>
          <div>曲谱最多可添加9个</div>
        </div>
      </div>
    </div>
    <div class="page_bottom" :style="`width:${pageInfoWidth}px`">
      <div class="mwow-button-filled mini" @click="goBack">取消</div>
      <div class="mwow-button-filled mini success" @click="postData">
        发布练习
      </div>
    </div>
    <!-- 选择弹框 -->
    <el-dialog
      title="在读学员"
      :visible.sync="choosestudent"
      width="50%"
      :modal-append-to-body="false"
    >
      <div>
        <el-form
          size="mini"
          ref="formtwo"
          inline
          label-width="65px"
          class="dialogForm"
          @submit.native.prevent
        >
          <el-form-item label="学员搜索：" label-width="85px">
            <el-input
              placeholder="学员姓名"
              prefix-icon="el-icon-search"
              v-model="class_name"
              @change="getdata"
              maxlength="30"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="alreadChoose">
        <div class="chooseTitle">已选学员:</div>
        <div class="chooseInfo">
          <div class="alreadChooseText">
            已选择<span> {{ allchoose.length }} </span>人
          </div>
          <div class="alreadChooseSpan">
            <span class="name" v-for="(item, index) in allchoose" :key="index">
              {{ item.name }}
              <span
                class="el-icon-error"
                @click="handleTeacherSelect(item)"
              ></span>
            </span>
          </div>
        </div>
      </div>
      <div class="treebox" style="height: 450px" v-infinite-scroll="load">
        <div>
          <el-table
            :data="checkboxData"
            v-horizontal-scroll
            size="mini"
            stripe
            style="width: 100%"
            tooltip-effect="dark"
            ref="menuTree"
            height="450"
          >
            <el-table-column width="42" align="center">
              <template slot-scope="scope">
                <el-checkbox
                  v-model="scope.row.checked"
                  @change="handleTeacherSelect(scope.row)"
                ></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="学员姓名"> </el-table-column>
            <el-table-column prop="status" label="学员状态">
              <template slot-scope="scope">
                <div class="mwow-green" v-if="scope.row.status === 2">在读</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div style="height: 35px">
        <el-pagination
          :current-page="page"
          small
          :page-size="pageSize"
          :page-sizes="pageSizeArray"
          :style="{ float: 'right', padding: '20px' }"
          :total="total"
          @current-change="handlePagerChange"
          @size-change="handlePagerSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="footerInfo">
          <div class="footerBtn">
            <div
              @click="choosestudent = false"
              class="mwow-button-filled mini btnsize"
            >
              取 消
            </div>
            <div
              class="mwow-button-filled mini success btnsize"
              @click="confirmClick(1)"
            >
              确 定
            </div>
          </div>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      title="点名课次"
      :visible.sync="choosestudenttwo"
      width="50%"
      :modal-append-to-body="false"
    >
      <div>
        <!-- <div class="tips">
          <i class="el-icon-warning"></i>
          只显示已点名课次
        </div> -->
        <el-form
          size="mini"
          ref="formtwo"
          inline
          label-width="65px"
          class="dialogForm"
          @submit.native.prevent
        >
          <el-form-item label="班级名称：" label-width="85px">
            <el-select
              v-model.number="dialogClassId"
              filterable
              clearable
              placeholder="请选择"
              @clear="getSelectrList('class')"
              @change="getdata"
              :filter-method="
                (queryString) => {
                  globalSearch(queryString, 'class');
                }
              "
            >
              <el-option
                v-for="item in className"
                :key="item.class_id"
                :label="item.name"
                :value="Number(item.class_id)"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上课时间：" label-width="85px">
            <el-date-picker
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="timestamp"
              v-model="expireTime"
              @change="datechoose"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="alreadChoose">
        <div class="chooseTitle">已选学员:</div>
        <div class="chooseInfo">
          <div class="alreadChooseText">
            已选择<span> {{ allchoose.length }} </span>人
          </div>
          <div class="alreadChooseSpan">
            <span class="name" v-for="(item, index) in allchoose" :key="index">
              {{ item.student_name }}
            </span>
          </div>
        </div>
      </div>
      <div class="treebox" v-infinite-scroll="load">
        <!-- <el-tree
          :data="checkboxDatatwo"
          :props="checkpropstwo"
          :load="loadNodetwo"
          lazy
          show-checkbox
          ref="menuTreetwo"
          @check="checkchoose"
        >
          <span slot-scope="{ node, data }">
            <span
              >{{ node.label }}
              <span v-if="node.level == 1"
                >{{ data.date }} {{ data.start_time.slice(0, 5) }} 周{{
                  ["日", "一", "二", "三", "四", "五", "六"][data.week_day]
                }}</span
              >
              <span
                v-if="node.level == 1"
                :class="!!node.checked ? 'checkedcolor' : ''"
                >( {{ data.student_count }}人)</span
              >
              <span
                class="mwow-tag primary-filled"
                style="margin: 0 4px"
                v-if="node.level == 2 && data.student_type === 1"
                >临时</span
              >
              <span
                class="mwow-tag inter-filled"
                style="margin: 0 4px"
                v-if="node.level == 2 && data.student_type === 5"
                >体验</span
              >
              <span
                class="mwow-tag del-filled"
                style="margin: 0 4px"
                v-if="node.level == 2 && data.student_type === 3"
                >补课</span
              >
              <span
                class="mwow-tag del-filled"
                style="margin: 0 4px"
                v-if="node.level == 2 && data.student_type === 2"
                >调课</span
              >
            </span>
          </span>
        </el-tree> -->
        <div v-for="item in checkboxDatatwo" :key="item.lesson_id">
          <div class="lesson-tree">
            <i
              @click="handleIcon(item)"
              style="margin: 0 3px; font-size: 16px"
              :class="
                item.showChild ? 'el-icon-caret-bottom' : 'el-icon-caret-right'
              "
            ></i>
            <el-checkbox-group v-model="item.checked">
              <el-checkbox :label="item.checked" @change="handleChecked(item)">
                <span> </span>
              </el-checkbox>
            </el-checkbox-group>
            <div class="cu-po">
              <p>
                {{ item.class_name }}
                <span
                  >{{ item.label }}
                  <span
                    >{{ item.date }} {{ item.start_time.slice(0, 5) }} 周{{
                      ["日", "一", "二", "三", "四", "五", "六"][item.week_day]
                    }}</span
                  >
                  <span :class="!!item.checked ? 'checkedcolor' : ''"
                    >( {{ item.student_count }}人)</span
                  >
                </span>
              </p>
            </div>
          </div>
          <div
            v-show="item.showChild"
            class="child-tree"
            v-if="lessonChildList.length > 0 && lessonId === item.lesson_id"
          >
            <div v-for="it in lessonChildList" :key="it.student_id">
              <el-checkbox-group v-model="it.ChildChecked">
                <el-checkbox
                  :disabled="it.student_type === 5"
                  :label="it.ChildChecked"
                  @change="handleChildChecked(item, it)"
                >
                  <div>
                    {{ it.student_name }}
                    <span
                      class="mwow-tag primary-filled"
                      style="margin: 0 4px"
                      v-if="it.student_type === 1"
                      >临时</span
                    >
                    <span
                      class="mwow-tag inter-filled"
                      style="margin: 0 4px"
                      v-if="it.student_type === 5"
                      >体验</span
                    >
                    <span
                      class="mwow-tag del-filled"
                      style="margin: 0 4px"
                      v-if="it.student_type === 3"
                      >补课</span
                    >
                    <span
                      class="mwow-tag del-filled"
                      style="margin: 0 4px"
                      v-if="it.student_type === 2"
                      >调课</span
                    >
                  </div>
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="footerInfo">
          <div class="footerBtn">
            <div
              @click="choosestudenttwo = false"
              class="mwow-button-filled mini btnsize"
            >
              取 消
            </div>
            <div
              class="mwow-button-filled mini success btnsize"
              @click="confirmClick(2)"
            >
              确 定
            </div>
          </div>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  homeworkAdd,
  classStudentList,
  lessonList,
  lessonStudentList,
} from "@/api/homework";
import {
  searchStudent,
  getSelectClassList,
  autoSearchData,
} from "@/api/globalSearch";
import uploadBox from "./uploadBox.vue";
import eventBus from "@/utils/bus";
import { dateFormat } from "@/utils/timeFormat";
export default {
  components: {
    uploadBox,
  },
  data() {
    return {
      lessonChildList: [],
      lessonId: -1, // 用来判断是否相等
      lessonChecked: false,
      // deadendTime: 0, // 截止时间
      searchInfo: {
        title: "",
        type: "",
        publish_type: 1,
        // deadlineTime: "", // 截止时间
        content_list: [],
        class_students: [
          {
            lesson_id: 0,
          },
        ],
      },
      student_type: [
        { value: "学员类", key: 1 },
        { value: "课次类", key: 2 },
      ],
      studentName: "",
      expireTimeClass: "",
      LessonList: [],
      rules: {
        title: [{ required: true, message: "请输入练习名称", trigger: "blur" }],
        type: [
          { required: true, message: "请选择发布类型", trigger: "change" },
        ],
        publish_type: [{ required: true, message: "请选择发布时间" }],
        // deadlineTime: [{ required: true, message: "请选择截止时间" }],
      },
      choosestudent: false,
      choosestudenttwo: false,
      checkprops: {
        label: "name",
        isLeaf: "leaf",
      },
      checkpropstwo: {
        label: "class_name",
        isLeaf: "leaf",
      },
      checkboxData: [],
      checkboxDatatwo: [],
      classListPage: 1,
      lessionListPage: 1,
      loading: false,
      class_name: "",
      dialogClassId: "",
      className: "",
      expireTime: [],
      start_time: "",
      end_time: "",
      allpeople: 0,
      allchoose: [],
      jumpList: [], // 跳转过来选中的人数
      cuttentTime: "",
      studentData: [],
      tableData: [],
      jumpLessonId: 0, // 跳转过来的lessonId
      pageInfoWidth: 1727,
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      selectedObject: {},
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.cuttentTime = minDate.getTime();
          if (maxDate) {
            this.cuttentTime = "";
          }
        },
        disabledDate: (time) => {
          if (this.cuttentTime != "") {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.cuttentTime - one;
            const maxTime = this.cuttentTime + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        },
      },
      expireTimeOption: {
        disabledDate: (time) => {
          // Math.floor(Date.now() / 1000)
          // Date.now()- (1 * 24 * 3600 * 1000)
          return time.getTime() < Date.now() - 1 * 24 * 3600 * 1000;
        },
      },
      // deadlineTimeOption: {
      //   disabledDate: (time) => {
      //     // Math.floor(Date.now() / 1000)
      //     // Date.now()- (1 * 24 * 3600 * 1000)
      //     return time.getTime() < Date.now() - 1 * 24 * 3600 * 1000;
      //   },
      // },
      menuTreeClick: false,
      lessonChildListCache: {}, // 课时学员缓存
    };
  },
  created() {
    let sidebarWidth = 0;
    let winWidth = document.documentElement.clientWidth;
    window.addEventListener("resize", () => {
      winWidth = document.documentElement.clientWidth;
      this.pageInfoWidth = winWidth - sidebarWidth - 30;
    });
    eventBus.$on("leftSidebar", (v) => {
      sidebarWidth = v;
      this.pageInfoWidth = winWidth - v - 30;
    });
    const _t = this;
    const date = new Date();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    if (month < 10) {
      month = "0" + month;
    }
    if (day < 10) {
      day = "0" + day;
    }
    _t.searchInfo.title = month + "月" + day + "日 - 练习";
    // 课次选择默认选中7天
    const one = 7 * 24 * 3600 * 1000;
    const minTime = new Date().getTime();
    const maxTime = minTime + one;
    _t.expireTime = [minTime, maxTime];
    _t.start_time = parseInt(_t.expireTime[0] / 1000 + "");
    _t.end_time = parseInt(_t.expireTime[1] / 1000 + "");
    _t.globalSearch("", "class");
    // 从时间课表的课次详情跳转过来的数据
    const class_id = _t.$route.query.id;
    const lesson_id = _t.$route.query.lid;
    const queryDate = _t.$route.query.date;
    if (_t.$route.query.id) {
      lessonStudentList({
        class_id: class_id,
        lesson_id: lesson_id,
      }).then((res) => {
        if (res.error_code === 0) {
          _t.studentData = res.data.list.filter((item) => {
            if (item.student_type === 0) {
              return item;
            }
          });
          _t.allpeople = res.data.list.length;
          _t.jumpList = res.data.list;
          const checkArr = [];
          let class_students = [];
          _t.searchInfo.type = 2;
          if (checkArr != []) {
            if (_t.searchInfo.type == 1) {
              class_students = _t.mergeArr(res.data.list, "class_id");
            } else {
              class_students = _t.mergeArr(res.data.list, "lesson_id");
            }
            class_students.map((a) => {
              if (_t.searchInfo.type == 2) {
                delete a.lesson_id;
              }
            });
            _t.searchInfo.class_students = class_students;
          }
        }
      });
    }
    if (queryDate) {
      _t.expireTime = [
        new Date(queryDate).getTime(),
        new Date(queryDate).getTime(),
      ];
      _t.datechoose(_t.expireTime);
      _t.jumpLessonId = Number(lesson_id);
    }
    this.handleRadioGroup(1);
  },
  beforeDestroy() {
    eventBus.$off("leftSidebar");
    window.removeEventListener("resize", () => {});
  },
  methods: {
    async handleIcon(val) {
      this.lessonChildList = [];
      this.lessonId = val.lesson_id;
      this.checkboxDatatwo.map((item) => {
        if (item.lesson_id === val.lesson_id) {
          item.showChild = !item.showChild;
        } else {
          item.showChild = false;
        }
        if (item.showChild) {
          let cache = this.lessonChildListCache[val.lesson_id];
          if (cache) {
            cache.map((item) => {
              if (val.checked && item.student_type !== 5) {
                item.ChildChecked = true;
              } else {
                item.ChildChecked = false;
              }
            });
            this.lessonChildList = cache;
          } else {
            lessonStudentList({
              class_id: val.class_id,
              lesson_id: val.lesson_id,
            }).then((res) => {
              if (res.error_code === 0) {
                this.lessonChildListCache[val.lesson_id] = res.data.list;
                res.data.list.map((item) => {
                  if (val.checked && item.student_type !== 5) {
                    item.ChildChecked = true;
                  } else {
                    item.ChildChecked = false;
                  }
                });
                this.lessonChildList = res.data.list;
              }
            });
          }
        }
      });
    },
    async handleChecked(val) {
      this.lessonId = val.lesson_id;
      let selectArr = [];
      const allchooseArr = [];
      const newArr = JSON.parse(JSON.stringify(this.checkboxDatatwo));
      newArr.map((item) => {
        if (item.lesson_id === val.lesson_id) {
          item.checked = val.checked;
          item.showChild = val.checked;
        } else {
          item.checked = false;
          item.showChild = false;
        }
      });
      this.checkboxDatatwo = newArr;
      if (val.checked) {
        let cache = this.lessonChildListCache[val.lesson_id];
        if (cache) {
          cache.map((item) => {
            if (val.checked && item.student_type !== 5) {
              item.ChildChecked = true;
            } else {
              item.ChildChecked = false;
            }
          });
          selectArr = cache;
          this.lessonChildList = cache;
        } else {
          await lessonStudentList({
            class_id: val.class_id,
            lesson_id: val.lesson_id,
          }).then((res) => {
            if (res.error_code === 0) {
              this.lessonChildListCache[val.lesson_id] = res.data.list;
              res.data.list.map((item) => {
                if (val.checked && item.student_type !== 5) {
                  item.ChildChecked = true;
                } else {
                  item.ChildChecked = false;
                }
              });
              this.lessonChildList = res.data.list;
              selectArr = res.data.list;
            }
          });
        }
      } else {
        this.lessonChildList = [];
      }
      selectArr.map((a, b) => {
        if (a.ChildChecked) {
          allchooseArr.push(a);
        }
      });
      this.allchoose = allchooseArr;
    },
    handleChildChecked(val, studentVal) {
      // 是否全部选中
      let allTrue = 0;
      const newChildArr = JSON.parse(JSON.stringify(this.lessonChildList));
      const allchooseArr = [];
      newChildArr.map((item, index) => {
        if (item.ChildChecked) {
          allchooseArr.push(item);
        }
        if (item.ChildChecked) {
          allTrue = allTrue + 1;
          return;
        }
      });
      this.checkboxDatatwo.map((item) => {
        if (item.lesson_id !== val.lesson_id) {
          item.checked = false;
        } else {
          if (allTrue === newChildArr.length) {
            item.checked = true;
          } else {
            item.checked = false;
          }
        }
      });
      this.allchoose = allchooseArr;
    },
    handleTeacherSelect(row) {
      const copy = { ...this.selectedObject };
      if (copy[row.student_id]) {
        delete copy[row.student_id];
      } else {
        copy[row.student_id] = row;
      }
      this.selectedObject = copy;
      const items = [];
      for (const key in copy) {
        items.push(copy[key]);
      }
      this.allchoose = items;
      const index = this.checkboxData.findIndex((item) => {
        return item.student_id === row.student_id;
      });
      if (index >= 0) {
        this.checkboxData[index].checked = !!copy[row.student_id];
      }
    },
    handleRadioGroup(v) {
      // if (v === 1) {
      //   const sevenDay = Date.now() + 6 * 24 * 3600 * 1000;
      //   this.searchInfo.deadlineTime = dateFormat("YYYY-mm-dd HH", sevenDay);
      //   this.deadendTime = sevenDay;
      // }
    },
    handlePagerChange(e) {
      this.classListData({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.classListData({
        page: 1,
        page_size: e,
      });
    },
    // checkchoose(e: any, a: any) {
    //   var _t = this as any;
    //   var array = a.checkedNodes;
    //   var allchoose: any = [];
    //   if (_t.searchInfo.type == 1 && !!e.fristLevel) {
    //     const currentCode = e.class_id;
    //     const current: any = Array.from(_t.$refs.menuTree.$children).filter(
    //       (child: any) => {
    //         return child.node.data.class_id === currentCode;
    //       }
    //     )[0];
    //     current.$el.childNodes[0].childNodes[0].click();
    //   } else if (_t.searchInfo.type == 2 && !!e.fristLevel) {
    //     const currentCode = e.lesson_id;
    //     // const current: any = Array.from(_t.$refs.menuTreetwo.$children).filter(
    //     //   (child: any) => {
    //     //     return child.node.data.lesson_id === currentCode;
    //     //   }
    //     // )[0];
    //     // current.$el.childNodes[0].childNodes[0].click();
    //   }
    //   array.map((a: any, b: number) => {
    //     if (!!a.fristLevel) {
    //     } else {
    //       allchoose.push(a);
    //     }
    //   });
    //   _t.allchoose = allchoose;
    // }
    // 处理发布练习的数据
    mergeArr(arr, tagerName) {
      const newArr = [];
      arr.forEach((item) => {
        const dataItem = item;
        if (newArr.length > 0) {
          const filterValue = newArr.filter((v) => {
            return v["" + tagerName + ""] == dataItem["" + tagerName + ""];
          });
          if (filterValue.length > 0) {
            newArr.forEach((n) => {
              if (
                n["" + tagerName + ""] == filterValue[0]["" + tagerName + ""]
              ) {
                n.student_ids.push(dataItem.student_id);
              }
            });
          } else {
            let newDataItem = {};
            if (tagerName == "lesson_id") {
              newDataItem = {
                lesson_id: dataItem.lesson_id,
                class_id: dataItem.class_id,
                student_ids: [dataItem.student_id],
              };
            } else {
              newDataItem = {
                class_id: dataItem.class_id,
                student_ids: [dataItem.student_id],
              };
            }
            newArr.push(newDataItem);
          }
        } else {
          let newDataItem = {};
          if (tagerName == "lesson_id") {
            newDataItem = {
              lesson_id: dataItem.lesson_id,
              class_id: dataItem.class_id,
              student_ids: [dataItem.student_id],
            };
          } else {
            newDataItem = {
              class_id: dataItem.class_id,
              student_ids: [dataItem.student_id],
            };
          }
          newArr.push(newDataItem);
        }
      });
      return newArr;
    },
    datechoose(e) {
      const _t = this;
      let expire_start_time = "";
      let expire_end_time = "";
      if (e != null) {
        expire_start_time = e[0] / 1000;
        expire_end_time = e[1] / 1000;
      }
      _t.start_time = expire_start_time;
      _t.end_time = expire_end_time;
      _t.getdata();
    },
    confirmClick(v) {
      const _t = this;
      let checkArr = [];
      if (_t.searchInfo.type == 1) {
        checkArr = this.allchoose;
      } else {
        checkArr = this.allchoose;
      }
      let class_students = [];
      _t.allpeople = 0;
      if (checkArr != []) {
        if (_t.searchInfo.type == 1) {
          class_students = _t.mergeArr(checkArr, "class_id");
        } else {
          class_students = _t.mergeArr(checkArr, "lesson_id");
        }
        class_students.map((a) => {
          _t.allpeople += Number(a.student_ids.length);
          if (_t.searchInfo.type == 2) {
            delete a.lesson_id;
          }
          // 传值
          if (v === 1) {
            a.class_id = 0;
            a.lesson_id = 0;
          } else if (v === 2) {
            a.lesson_id = checkArr[0].lesson_id;
          }
        });
        _t.choosestudent = false;
        _t.choosestudenttwo = false;
        _t.searchInfo.class_students = class_students;
      }
    },
    changeInputAgain() {
      const _t = this;
      if (_t.searchInfo.type == 1) {
        _t.choosestudent = true;
      } else {
        _t.choosestudenttwo = true;
      }
    },
    changeInput(e) {
      const _t = this;
      _t.$refs.multiSelect.blur();
      _t.loading = false;
      if (e == 1) {
        _t.choosestudent = true;
        if (_t.checkboxData.length == 0) {
          _t.allchoose = [];
          _t.classListData({
            page: 1,
            page_size: 10,
          });
          _t.checkboxDatatwo = [];
        }
      } else if (e == 2) {
        _t.choosestudenttwo = true;
        if (_t.checkboxDatatwo.length == 0) {
          _t.allchoose = [];
          _t.getlessonList({
            page: 1,
            page_size: 10,
          });
          _t.checkboxData = [];
        }
      }
    },
    load() {
      const _t = this;
      if (_t.loading == false) {
        if (_t.searchInfo.type == 1) {
          // // _t.classListPage += 1;
          // _t.classListData({
          //   page: _t.classListPage,
          //   page_size: 10,
          // });
        } else {
          _t.lessionListPage += 1;
          _t.getlessonList({
            page: _t.lessionListPage,
            page_size: 10,
          });
        }
      }
    },
    async loadNode(node, res) {
      const _t = this;
      if (node.level >= 1) {
        const list = await classStudentList({ class_id: node.data.class_id });
        if (list.data.list != []) {
          list.data.list.map((a) => {
            a.leaf = true;
          });
        }
        res(list.data.list);
        let checkArr = [];
        const newarry = [];
        checkArr = _t.$refs.menuTree.getCheckedNodes(true, false);
        if (checkArr != []) {
          checkArr.map((a, b) => {
            if (!a.fristLevel) {
              newarry.push(a);
            }
          });
        }
        _t.allchoose = newarry;
      }
    },
    async loadNodetwo(node, res) {
      const _t = this;
      if (node.level >= 1) {
        const list = await lessonStudentList({
          class_id: node.data.class_id,
          lesson_id: node.data.lesson_id,
        });
        if (list.data.list != []) {
          list.data.list.map((a) => {
            a.leaf = true;
            a.class_name = a.student_name;
            if (a.student_type === 5) {
              a.disabled = true;
            }
          });
        }
        res(list.data.list);
        let checkArr = [];
        const newarry = [];
        checkArr = _t.$refs.menuTreetwo.getCheckedNodes(true, false);
        if (checkArr != []) {
          checkArr.map((a, b) => {
            if (!a.fristLevel) {
              newarry.push(a);
            }
          });
        }
        _t.allchoose = newarry;
      }
    },
    getdata() {
      const _t = this;
      if (_t.searchInfo.type == 1) {
        _t.classListData({
          page: 1,
          page_size: 10,
        });
      } else {
        _t.getlessonList({
          page: 1,
          page_size: 10,
        });
      }
    },
    classListData(data) {
      const _t = this;
      data.key_word = _t.class_name;
      data.status = [2];
      _t.loading = true;
      searchStudent(data).then((res) => {
        if (res.error_code == 0) {
          _t.total = res.data.total;
          res.data.list.map((it) => {
            if (this.selectedObject[it.student_id]) {
              it.checked = true;
            } else {
              it.checked = false;
            }
          });
          _t.checkboxData = res.data.list;
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    getlessonList(data) {
      const _t = this;
      data.class_id = _t.dialogClassId;
      data.start_time = _t.start_time;
      data.end_time = _t.end_time;
      _t.loading = true;
      lessonList(data).then((res) => {
        if (res.error_code == 0) {
          const lid = Number(_t.$route.query.lid);
          if (_t.jumpList.length > 0) {
            _t.allchoose = _t.jumpList;
            const copy = { ...this.selectedObject };
            _t.jumpList.map((row) => {
              if (copy[row.student_id]) {
                delete copy[row.student_id];
              } else {
                copy[row.student_id] = row;
              }
            });
            this.selectedObject = copy;
            _t.jumpList = [];
          }
          res.data.list.map((item) => {
            if (lid && item.lesson_id === lid) {
              item.checked = true;
            } else {
              item.checked = false;
            }
            item.showChild = false;
          });
          if (res.data.list != null) {
            res.data.list.map((a) => {
              a.fristLevel = true;
            });
          }
          if (data.page == 1) {
            _t.checkboxDatatwo = res.data.list;
            _t.loading = false;
            return;
          }
          if (res.data.list.length > 0) {
            let checkboxDatatwo = [];
            checkboxDatatwo = res.data.list;
            _t.checkboxDatatwo.push(...checkboxDatatwo);
            _t.loading = false;
          }
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    contentList(e) {
      const _t = this;
      const newarry = JSON.parse(JSON.stringify(e));
      newarry.map((a) => {
        if (a.url) {
          delete a.url;
        }
        if (a.uid) {
          delete a.uid;
        }
        return a;
      });
      _t.searchInfo.content_list = newarry;
    },
    setCoverS(res) {
      const _t = this;
      _t.searchInfo.images.push(res.data.object);
    },
    delImg(res) {
      const _t = this;
      _t.searchInfo.images.splice(res, 1);
    },
    // 发布练习
    postData() {
      const _t = this;
      let params = {
        title: this.searchInfo.title,
        content_list: this.searchInfo.content_list,
        type: this.searchInfo.type,
        publish_type: this.searchInfo.publish_type,
        publish_time: this.searchInfo.publish_time,
        // deadline_time: this.searchInfo.deadline_time,
        class_students: this.searchInfo.class_students,
      };
      if (this.searchInfo.content_list !== undefined) {
        if (
          _t.searchInfo.content_list.filter((item) => {
            return item.annex_type === 1;
          }).length > 9
        ) {
          _t.$message({
            type: "warning",
            message: "图片数不能超过9个",
          });
          return;
        }
        if (
          _t.searchInfo.content_list.filter((item) => {
            return item.annex_type === 2;
          }).length > 9
        ) {
          _t.$message({
            type: "warning",
            message: "视频数不能超过9个",
          });
          return;
        }
        if (
          _t.searchInfo.content_list.filter((item) => {
            return item.annex_type === 4;
          }).length > 9
        ) {
          _t.$message({
            type: "warning",
            message: "音频数不能超过9个",
          });
          return;
        }
        if (
          _t.searchInfo.content_list.filter((item) => {
            return item.annex_type === 5;
          }).length > 9
        ) {
          _t.$message({
            type: "warning",
            message: "曲谱数不能超过9个",
          });
          return;
        }
      }
      _t.$refs["form"].validate((valid) => {
        if (valid) {
          if (_t.searchInfo.publish_type == 1) {
            params.publish_time = Date.parse(new Date() + "") / 1000;
          }
          // if (_t.deadendTime > 0) {
          //   const num = String(_t.deadendTime).slice(0, 10);
          //   params.deadline_time = Number(num);
          // }
          if (
            _t.searchInfo.type === 2 &&
            _t.searchInfo.class_students.length > 0
          ) {
            if (_t.searchInfo.class_students[0].lesson_id === undefined) {
              params.class_students[0].lesson_id = Number(
                this.$route.query.lid
              );
            }
          }
          params.content_list = params.content_list.map((item) => {
            return {
              annex_content: String(item.annex_content),
              annex_type: item.annex_type,
              sort: Number(item.sort) || 0,
            };
          });
          homeworkAdd(params).then((res) => {
            if (res.error_code == 0) {
              _t.$message({
                type: "success",
                message: "发布成功!",
              });
              _t.goBack();
            } else {
              _t.$message({
                type: "error",
                message: res.message,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    datechooseClass(e) {
      const _t = this;
      _t.expireTimeClass = _t.expireTimeClass + ":00" + ":00";
      const time = new Date(_t.expireTimeClass);
      const startAt = (time * 1000) / 1000000;
      _t.searchInfo.publish_time = startAt;
      // 发布时间必须在当前时间之后
      const now = new Date().getTime();
      if (time.getTime() < now) {
        _t.$message({
          type: "warning",
          message: "发布时间必须在当前时间之后",
        });
        _t.expireTimeClass = "";
        return false;
      }
      // 自动设置截止时间
      if (_t.searchInfo.publish_type === 2 && _t.searchInfo.publish_time) {
        const sevenDay =
          _t.searchInfo.publish_time * 1000 + 6 * 24 * 3600 * 1000;
        // _t.searchInfo.deadlineTime = dateFormat("YYYY-mm-dd HH", sevenDay);
        // _t.deadendTime = sevenDay;
      }
    },
    dateDeadline(e) {
      // const time = new Date(e + ":00" + ":00").getTime();
      // this.deadendTime = time;
    },
    goBack() {
      this.$router.go(-1);
    },
    // 通用搜索框
    getSelectrList(e) {
      const _t = this;
      _t.globalSearch("", e);
    },
    getglobalsearchdata(data, type) {
      return getSelectClassList(data);
    },
    async globalSearch(queryString, type) {
      const _t = this;
      let data = {
        page: 1,
        page_size: 100,
      };
      let restaurants = {};
      if (queryString) {
        data = {
          page: 1,
          page_size: 10,
        };
        if (type == "class") {
          data.name = queryString;
        } else if (type == "course") {
          data.title = queryString;
        } else {
          data.key_word = queryString;
        }
      }
      restaurants = await _t.getglobalsearchdata(data, type);
      const list = restaurants.data.list;
      _t.className = list;
    },
    // 通用搜索框结束
  },
};
</script>

<style scoped lang="scss">
.add-homework-container {
  .checkedcolor {
    color: #07d1aa;
  }
  .dialogForm {
  }
  .tips {
    padding: 7px 10px;
    background: #fff7e9;
    color: #5c5d5e;
    font-size: 12px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    i {
      font-size: 16px;
      margin-right: 5px;
      color: #ffb940;
    }
  }
  .chooseIn {
    font-size: 12px;
    margin-right: 10px;
    cursor: pointer;
  }
  .footerInfo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .chooseNumber {
      font-size: 14px;
      color: #5c5d5e;
    }
    .footerBtn {
      .btnsize {
        // line-height: 28px !important;
      }
    }
  }
  .treebox {
    height: 250px;
    overflow-y: auto;
    border: 1px solid #e1e5e9;
  }
  .greencolor {
    color: #07d1aa;
    font-size: 10px;
  }
  /deep/ .el-upload_img {
    .el-upload {
      width: 80px;
      height: 80px;
      line-height: 95px;
    }
    li {
      height: 80px;
      width: 80px;
    }
  }
  .page_header {
    background: #fff;
    padding: 0 13px;
    border-radius: 4px 4px 0 0;
  }
  .publishBox {
    margin-top: 10px;
  }
  .page_header_left {
    display: flex;
    cursor: pointer;
    position: relative;
    align-items: center;
  }
  .el-icon-back {
    font-size: 18px;
    margin-right: 6px;
    align-self: center;
  }
  .el-icon-back:before {
    content: "\e6ea";
  }
  .page_header_left_back {
    font-size: 14px;
    font-weight: 500;
    margin-right: 40px;
    position: relative;
  }
  .page_header_left_back::after {
    content: "";
    position: absolute;
    width: 1px;
    height: 16px;
    right: -20px;
    top: 50%;
    transform: translateY(-50%);
    background-color: #dcdfe6;
  }
  .page_header_content {
    font-size: 13px;
    font-weight: bold;
    color: #5c5d5e;
  }
  .page_header_control {
    display: flex;
    div:nth-of-type(2) {
      margin: 0 10px;
    }
  }
  //中间
  .page_content,
  .page_content_bottom {
    background: #fff;
    padding: 13px;
    padding-top: 22px;
    min-height: 88%;
    border-radius: 0 0 4px 4px;
    margin-top: 12px;
    .publish_type_info {
      position: relative;
      top: 1px;
      color: #ff9562;
    }
    /deep/.special-radio-group {
      .el-radio-group {
        margin-top: 7px;
        width: 80px;
        line-height: 25px;
        .el-radio__inner::after {
          width: 14px;
          height: 14px;
          //点击后方框中的图片
          background-image: url("https://wowsite.musicwow.com/teaching_system_frontend/images/follow/success.png") !important;
          background-repeat: no-repeat;
          background-size: 14px 14px;
        }
      }
    }
    /deep/ .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9 !important;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 80px;
      height: 80px;
      line-height: 80px;
      text-align: center;
    }
    .avatar {
      width: 80px;
      height: 80px;
      display: block;
    }
    .fromtips {
      color: #9e9fa0;
      font-size: 12px;
      line-height: 33px;
    }
    .leaveTime {
      padding: 12px 20px 20px 20px;
      background: #f2f6fa;
      width: 766px;
      border-radius: 4px;
      .leaveTimeBox {
        color: #ffb940;
        font-size: 12px;
        margin-bottom: 12px;
      }
      .leaveTimeCenterBox {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        .leaveTimeSmCenter {
          border-radius: 4px;
          padding: 12px;
          min-width: 194px;
          background: #fff;
          color: #5c5d5e;
          font-size: 12px;
          line-height: 20px;
          margin-bottom: 10px;
          .leaveTimeFw {
            font-weight: bold;
          }
          .leaveTimeBtn {
            margin-top: 8px;
            padding-top: 8px;
            border-top: 1px solid #e3e4e5;
          }
        }
        .leaveTimeSmCenter:nth-of-type(3n + 2) {
          margin: 0 15px;
          margin-bottom: 10px;
        }
      }
    }
  }
  .page_bottom {
    position: fixed;
    bottom: 10px;
    background-color: #fff;
    display: flex;
    border-radius: 4px;
    padding: 8px 0;
    .info {
      margin-right: 10px;
      line-height: 22px !important;
    }
    :first-child {
      margin-left: 12px;
    }
    div {
      margin-right: 12px;
    }
  }
  .bottom_top {
    font-size: 14px;
    color: #5c5d5e;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .excisetips {
    margin-left: 80px;
  }
  .tipsBottom {
    color: #9e9fa0;
    font-size: 12px;
    margin-bottom: 40px;
    div {
      margin-top: 10px;
    }
  }
  .alreadChoose {
    display: flex;
    .chooseTitle {
      font-size: 12px;
      color: #5c5d5e;
      width: 85px;
    }
    .alreadChooseText {
      font-size: 12px;
      color: #5c5d5e;
      span {
        color: #07d1aa;
      }
    }
    .chooseInfo {
      flex: 1;
    }
    .alreadChooseSpan {
      margin: 14px 0;
      .name {
        color: #07d1aa;
        display: inline-block;
        line-height: normal;
        position: relative;
        padding: 8px 10px 8px 10px;
        border: 1px solid #e7e8ea;
        border-radius: 4px;
        margin-right: 4px;
        margin-bottom: 4px;
        i {
          color: #fff;
          font-size: 10px;
          width: 15px;
          height: 15px;
          background: #d8d8d8;
          border-radius: 50%;
          display: inline-block;
          text-align: center;
          line-height: 16px;
          cursor: pointer;
        }
      }
    }
  }
}
.lesson-tree {
  display: flex;
  align-items: center;
  height: 22px;
  /deep/ .is-checked {
    border-color: #07d1aa !important;
    color: #606266 !important;
    .el-checkbox__inner {
      border-color: #07d1aa !important;
      background-color: #07d1aa !important;
    }
    .el-checkbox__label {
      color: #606266 !important;
    }
  }
}
.child-tree {
  display: block;
  margin-left: 35px;
  /deep/ .is-checked {
    border-color: #07d1aa !important;
    color: #606266 !important;
    .el-checkbox__inner {
      border-color: #07d1aa !important;
      background-color: #07d1aa !important;
    }
    .el-checkbox__label {
      color: #606266 !important;
    }
  }
}
.el-icon-error {
  color: #ccc;
  cursor: pointer;
}
</style>
